import React from "react";
import { jsPDF } from "jspdf";
import Anlook from "../../images/Anlook.svg"; 
const Invoice = ({item}) => {
  const invoiceData = {
    invoiceNumber: "10000810901",
    companyName: "WebPros International LLC",
    dba: "DBA cPanel LLC",
    address:
      "2550 N Loop W Suite 4006, Houston, TX 77092-8902, United States of America",
    customerService: {
      hours: "6AM-6PM Monday-Friday, 6AM-4PM Saturday-Sunday",
      email: "cs@cpanel.net",
    },
    grandTotal: "Rs. 1.00",
    customer: {
      name: "Radha Krishna Singh",
      company: "XYZ Pvt Ltd",
      email: "radha.krishna@bumppy.com",
      taxID: "09AAHCB8430D1ZS",
      address: "Noida Stays , Sector 66, Noida, Uttar Pradesh",
    },
    company: {
      companyName: "Anlook",
      contactNumber: "98989889898",
      website: "anlook.com",
      email: "support@anlook.com",
      address: "B-218 Ithum Tower, Sector 62, Noida, Uttar Pradesh",
      GSTNumber: "IAZHSXXXXXXX8787",
    },
    invoiceDate: "22/12 /2024",
    paymentMethod: "Credit Card",
    paymentStatus: "PAID",
    items: [
      {
        description: "Trial Plan - This is description for Monthly Trial Plan",
        price: "Rs. 1.00",
        planDuration: "For 7 Days",
      },
    ],
    subTotal: "Rs. 1.00",
    IGST: "0.00% IGST Rs. 0.00",
    credits: "Rs. 0.00",
    transactions: [
      {
        date: "Wednesday, September 4th, 2024",
        method: "Credit Card",
        transactionID: "txn_3PvWDREkDYgjJiVg1x8PAGkd",
        amount: "Rs. 1.00",
      },
    ],
    balance: "Rs. 0.00",
    generatedOn: "Wednesday, September 4th, 2024",
  };
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const options = { year: "numeric", month: "long", day: "numeric" }; // Customize as needed
    return new Date(dateString).toLocaleDateString("en-US", options);
  };
  const generatePDF = () => {
    const doc = new jsPDF();
    const logoBase64 =
      "data:image/png;base64,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"; // Replace with actual Base64 string
      const htmlContent = `
      <div style="font-family: 'Arial', sans-serif; color: #333; padding: 20px; line-height: 1.5;">
        <div style="display: flex; justify-content: space-between; align-items: flex-start; background-color: #f9f9f9; padding: 15px; border-radius: 5px;">
          <div>
            <img src="${logoBase64}" alt="Order Confirmed" style="width: 150px; object-fit: contain;" />
            <table style="width: 100%; margin-top: 10px;">
              <tr><td style="font-weight: bold;"> ${item.organization_name} </td></tr>
              <tr><td> B-218 Ithum Tower, Sector 62, Noida, Uttar Pradesh </td></tr>
              <tr><td>GST No:&nbsp;&nbsp; ${item.organization_gst}</td></tr>
              <tr><td>Contact: ${invoiceData.company.email.trim()}</td></tr>
            </table>
          </div>
          <div style="text-align: right;">
            <h6 style="font-weight: normal; margin: 0px;text-align:center"><strong>Date : </strong>  ${formatDate(item.purchased_on)}</h6>
            <h1 style="color: #007bff; font-size: 28px; margin: 5px 0;">${item.invoice_id}</h1>
          </div>
        </div>
        <hr style="border: 1px solid #007bff; margin: 20px 0;" />
        <div style="background-color: #f9f9f9; padding: 15px; border-radius: 5px; margin-bottom: 20px;">
          <h3 style="color: #007bff; font-size: 20px; margin: 0;">Bill To :</h3>
          <table style="width: 100%; margin: 10px 0;">
            <tr><td><strong>${item.user_name}</strong></td></tr>
            <tr><td>Contact No. :&nbsp;&nbsp;${item.user_mobile}</td></tr>
            <tr><td>E-Mail :&nbsp;&nbsp; ${item.user_email}</td></tr>
            <tr><td>GST :&nbsp;&nbsp; ${item.company_gst}</td></tr>
          </table>
        </div>
        <h3 style="color: #007bff; font-size: 20px;">Items</h3>
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px; border: 1px solid #ccc;">
          <thead>
            <tr style="background-color: rgba(1, 195, 125, 1); color: white;">
              <th style="padding: 10px; text-align: left;">Description</th>
              <th style="padding: 10px; text-align: right;">Price</th>
            </tr>
          </thead>
          <tbody>
              <tr style="background-color: ${"#f9f9f9" };">
                <td style="border: 1px solid #ccc; padding: 10px;">One Time Setup Fee </td>
                <td style="border: 1px solid #ccc; padding: 10px; text-align: right;">${item.setup_fee}</td>
              </tr>
              <tr style="background-color: ${"#f9f9f9" };">
                <td style="border: 1px solid #ccc; padding: 10px;">${item.plan_name} - ${item.plan_description}</td>
                <td style="border: 1px solid #ccc; padding: 10px; text-align: right;">${item.plan_price}</td>
              </tr>
          </tbody>
        </table>
        <h3 style="color: #007bff; font-size: 20px;">Summary</h3>
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
          <tr>
            <td style="border: 1px solid #ccc; padding: 10px;">Sub Total</td>
            <td style="border: 1px solid #ccc; padding: 10px; text-align: right;">  ${(+item.setup_fee + +item.plan_price).toFixed(2)}</td>
          </tr>
          <tr>
            <td style="border: 1px solid #ccc; padding: 10px;">GST</td>
            <td style="border: 1px solid #ccc; padding: 10px; text-align: right;">${item.plan_gst}</td>
          </tr>
          <tr>
            <td style="border: 1px solid rgba(1, 195, 125, 1); background-color: rgba(1, 195, 125, 1); color: white; padding: 10px;">Grand Total : </td>
            <td style="border: 1px solid rgba(1, 195, 125, 1); background-color: rgba(1, 195, 125, 1); color: white; padding: 10px; text-align: right;">${item.grand_total}</td>
          </tr>
        </table>
        <h3 style="color: #007bff; font-size: 20px;">Transactions</h3>
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
          <tr>
            <td style="border: 1px solid #ccc; padding: 10px;">Transaction Date:  ${formatDate(item.purchased_on)}</td>
          </tr>
          <tr>
            <td style="border: 1px solid #ccc; padding: 10px;">Transaction ID : ${item.transaction_number}</td>
          </tr>
          <tr>
            <td style="border: 1px solid #ccc; padding: 10px;">Amount: ${item.grand_total}</td>
          </tr>
           <tr>
            <td style="border: 1px solid #ccc; padding: 10px;">Payment Status: ${item.payment_status}</td>
          </tr>
        </table>
        <div style="text-align: center; margin-top: 40px; color: #555; font-size: 12px;">
          <p>Invoice Generated on  ${formatDate(item.purchased_on)}</p>
        </div>
      </div>
    `;

    
    doc.html(htmlContent, {
      callback: function (doc) {
        doc.save(`invoice_${invoiceData.invoiceNumber}.pdf`);
      },
      x: 10,
      y: 10,
      width: 190, // Max width of the content
      windowWidth: 900, // Simulated browser width for rendering
    });
  };
  return (
    <div>
      <div className="m-0 p-0 "> 
      <button onClick={generatePDF} className="downloadButton m-0 p-2 ">
         Invoice
      </button>
      </div>
      <style>{`
  .downloadButton {
    background: linear-gradient(135deg, rgba(1, 195, 125, 1), rgba(1, 160, 100, 1)); /* Gradient using your color */
    color: #ffffff; /* White text for contrast */
    border: none; /* Remove border */
    border-radius: 5px; /* Rounded corners */
    font-size: 0.9rem; /* Slightly smaller text */
    font-weight: 500; /* Medium font weight */
    padding: 15px 20px; /* Padding for a compact look */
    transition: all 0.3s ease; /* Smooth hover effect */
  }
  .downloadButton:hover {
    background: linear-gradient(135deg, rgba(1, 160, 100, 1), rgba(1, 195, 125, 1)); /* Reverse gradient */
    transform: translateY(-2px); /* Lift the button slightly */
    box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.15); /* Increase shadow on hover */
  }
  .downloadButton:active {
    transform: translateY(1px); /* Pressed state */
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1); /* Reduce shadow */
  }
`}</style>
    </div>
  );
};
export default Invoice;